import { isEmpty } from '@ember/utils'
import type StudentEventsService from 'district-ui-client/services/student-events'
import type { StatsScope } from 'district-ui-client/utils/student-events/stats-scope'
import type { NormalizedInterval } from 'date-fns'

export interface CourseProgressByGradeResponse {
  course_progress_by_grade: {
    grades: { grade_position: number; lesson_count: number; student_count: number }[]
    student_count: number
  }
}

export interface CourseProgressByGradeData {
  grades: {
    grade_position: number
    lesson_count: number
    student_count: number
  }[]
  student_count: number
}

export async function courseProgressByGrade(
  this: StudentEventsService,
  product: LegacyProductRe | LegacyProductRex | LegacyProductMs,
  precinct: LegacyPrecinctReading | LegacyPrecinctSpelling | LegacyPrecinctLessons | LegacyPrecinctMyLessons,
  statsScope: StatsScope,
  period: NormalizedInterval,
): Promise<Nullable<CourseProgressByGradeData>> {
  if (isEmpty(statsScope.ids)) return null

  const url = this.buildUrl('course_progress_by_grade', product, statsScope)
  const query = this.buildQuery(statsScope, period, { precinct })

  const data = await this.fetchData<CourseProgressByGradeResponse>(url, query)
  if (!data) return null

  const {
    course_progress_by_grade: { grades, student_count },
  } = data
  if (grades.length === 0) {
    return null
  }

  const sortedGrades = [...grades].sort((a, b) => a.grade_position - b.grade_position)

  return {
    grades: sortedGrades,
    student_count,
  }
}
